import * as React from 'react';
import { Grid } from '@mui/material';
import VMImageCard from './files-card';
import AddImageModal from './AddImageModal'
import PushImageModal from './PushImageModal'
import ImageSettingsBtn from './ImagesSettingsBtn'

export default function VMImages() {
  return (
    <>
      <div className='d-flex' style={{ justifyContent: "flex-end", marginRight: "3rem" }}>
        <PushImageModal />
        <div style={{ margin: "1rem" }}></div>
        <AddImageModal />
        <div style={{ margin: "1rem" }}></div>
        <ImageSettingsBtn />
      </div>
      <Grid
        style={{ marginTop: "1rem" }}
        className='content'
        container
        spacing={3}
        justifyContent="center"
      >
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <VMImageCard />
        </Grid>
      </Grid>
    </>
  );
}
